;(function ($) {
  "use strict"
  const currentLang = $("html").attr("lang")

  function exhibitionsSlider() {
    const slider = $(".image-slider.m-exhibitions").lightSlider({
      item: 1,
      enableDrag: true,
      pauseOnHover: true,
      adaptiveHeight: true,
      auto: true,
      speed: 600,
      pause: 3000,
      loop: false,
      controls: false,
      pager: false,
      onBeforeSlide: function (el) {
        const $sliderControls = $(el)
          .closest(".image-slider-wrapper")
          .find(".slider-controls")
        const currentSlide = el.getCurrentSlideCount()
        const totalSlides = el.getTotalSlideCount()

        // Don't show controls if there's only one slide
        if (totalSlides <= 1) {
          $sliderControls.hide()
          return
        } else {
          $sliderControls.show()
        }

        // Show/hide prev button
        if (currentSlide === 1) {
          $sliderControls.find(".slider-controls__prev").hide()
        } else {
          $sliderControls.find(".slider-controls__prev").show()
        }

        // Show/hide next button
        if (currentSlide === totalSlides) {
          $sliderControls.find(".slider-controls__next").hide()
        } else {
          $sliderControls.find(".slider-controls__next").show()
        }
      },
    })

    const $sliderControls = slider
      .closest(".image-slider-wrapper")
      .find(".slider-controls")

    // Event handlers for navigation
    $sliderControls.find(".slider-controls__prev").on("click", function () {
      slider.goToPrevSlide()
    })

    $sliderControls.find(".slider-controls__next").on("click", function () {
      slider.goToNextSlide()
    })
  }

  function gallerySlider() {
    const areaCarousels = []

    $("body")
      .find(".image-slider.m-gallery")
      .each(function (index) {
        areaCarousels[index] = $(this).lightSlider({
          item: 1,
          enableDrag: false,
          adaptiveHeight: true,
          auto: false,
          speed: 600,
          pause: 3000,
          loop: false,
          controls: false,
          pager: false,
          onSliderLoad: function (el) {
            el.lightGallery({
              selector: ".image-slider.m-gallery > .lslide",
              download: false,
              counter: true,
            })

            el.on("onAfterOpen.lg", function () {
              $(".lg-close")
                .addClass("button-close")
                .append('<span class="icon"></span>')
              $("body").addClass("no-scroll")
            })

            el.on("onCloseAfter.lg", function (event) {
              $("body").removeClass("no-scroll")
            })
          },
        })
      })

    // A bit complex because multiple sliders on
    //  the page. We need an external array to save
    // lightSlider object (that exposes the API)
    $.each(areaCarousels, function (index) {
      const lS_Object = areaCarousels[index]
      const $that = $(lS_Object)
      const $sliderControls = $that
        .closest(".image-slider-wrapper")
        .find(".slider-controls")

      if ($that.children().length === 1) {
        $sliderControls.hide()
      }

      $sliderControls.find(".slider-controls__prev").on("click", function () {
        lS_Object.goToPrevSlide()
      })

      $sliderControls.find(".slider-controls__next").on("click", function () {
        lS_Object.goToNextSlide()
      })
    })
  }

  function mobileMenu() {
    function toggleClasses() {
      $(".primary-navigation").toggleClass("is-visible")
      $("body").toggleClass("no-scroll")
    }

    $(document).on(
      "click",
      ".app-header__link button, .primary-navigation__header button",
      toggleClasses,
    )

    $(document).on("keydown", function (e) {
      if ($(".primary-navigation").hasClass("is-visible")) {
        if (e.key === "Escape") {
          toggleClasses()
        }
      }
    })
  }

  function customReveal() {
    // Open modal when clicking element with data-open attribute
    $(document).on("click", "[data-open]", function (e) {
      e.preventDefault()
      const targetId = $(this).attr("data-open")
      const $target = $("#" + targetId)

      // First make the modal visible but with opacity 0
      $target.css({ opacity: 0, display: "block" })
      // Add the active class immediately
      $target.addClass("is-active")
      // Add no-scroll to body
      $("body").addClass("no-scroll")
      // Then animate the opacity for a smoother transition
      $target.animate({ opacity: 1 }, 300)
    })

    // Close modal when clicking close button or background
    $(document).on("click", "[data-close], .reveal[data-reveal]", function (e) {
      if (e.target === this || $(e.target).closest("[data-close]").length) {
        const $modal = $(this).hasClass("reveal")
          ? $(this)
          : $(this).closest(".reveal")

        // Animate the opacity to 0
        $modal.animate({ opacity: 0 }, 300, function () {
          // Once animation is complete, remove class and hide
          $modal.removeClass("is-active")
          $modal.css("display", "none")
          $("body").removeClass("no-scroll")
        })
      }
    })

    // Prevent clicks inside modal from bubbling up to modal background
    $(document).on("click", ".reveal[data-reveal] > *", function (e) {
      e.stopPropagation()
    })

    // Close modal on ESC key
    $(document).on("keydown", function (e) {
      if (e.key === "Escape") {
        const $activeModal = $(".reveal.is-active")
        if ($activeModal.length) {
          // Animate the opacity to 0
          $activeModal.animate({ opacity: 0 }, 300, function () {
            // Once animation is complete, remove class and hide
            $activeModal.removeClass("is-active")
            $activeModal.css("display", "none")
            $("body").removeClass("no-scroll")
          })
        }
      }
    })
  }

  function handleNotifications() {
    // Handle closing notifications (elements with data-closable)
    $(document).on("click", "[data-closable] [data-close]", function (e) {
      e.preventDefault()
      const $notification = $(this).closest("[data-closable]")

      // Animate the opacity to 0
      $notification.animate({ opacity: 0 }, 300, function () {
        // Once animation is complete, remove the element
        $notification.remove()
      })
    })
  }

  function readMoreLess() {
    const readMoreText = currentLang === "en-GB" ? "Read more…" : "Lees meer…"
    const readLessText = currentLang === "en-GB" ? "Read less…" : "Lees minder…"
    const noOfParagraphs = 5

    if ($(".post-item__about").children().length > noOfParagraphs) {
      $(".post-item__about > *:gt('" + noOfParagraphs + "')").wrapAll(
        '<div class="more-text"></div>',
      )

      $(".post-item__about").append(
        '<button class="read-more">' + readMoreText + "</button>",
      )

      $(document).on("click", ".read-more", function () {
        $(".more-text").toggleClass("is-visible")

        $(this).html(
          $(".more-text").hasClass("is-visible") ? readLessText : readMoreText,
        )
      })
    }
  }

  function siteSplash() {
    if ($(".splash").length) {
      $(document).on("scroll click", function () {
        $(".splash").fadeOut(500, function () {
          $(this).remove()
        })
      })
    }
  }

  $(document).ready(function () {
    mobileMenu()
    imagesLoaded(".image-slider.m-exhibitions", function () {
      exhibitionsSlider()
    })
    imagesLoaded(".image-slider.m-gallery", function () {
      gallerySlider()
    })
    customReveal()
    handleNotifications()
    readMoreLess()
    siteSplash()
  })
})(jQuery)
